import Vue from 'vue'
import Router, {RouteConfig} from 'vue-router'
import Layout from '@/layout/index.vue'
import {UserModule} from "@/store/modules/user";

import adminRouter from '@/router/modules/admin';
import cmsRouter from '@/router/modules/cms';
import projectRouter from '@/router/modules/project';
import ouRouter from '@/router/modules/ou';
import auditRouter from "@/router/modules/audit";
import formRouter from "@/router/modules/form";

import partnerInviteRouter from "@/router/modules/partnerInvite";
import notifyRouter from "@/router/modules/notify";
import organizationRouter from "@/router/modules/organization";
import organizationApplyRouter from "@/router/modules/organizationApply";
import financeRouter from "@/router/modules/finance";
import fundRouter from "@/router/modules/fund";
import fundProjectRouter from "@/router/modules/fundProject";
import activityRouter from './modules/activity';
import volunteerRouter from './modules/volunteer';
import taskRouter from "@/router/modules/task";
import jobRouter from "@/router/modules/job";
import feedbackRouter from "@/router/modules/feedback";
import financeNewRouter from "@/router/modules/financeNew";
import officeRouter from "@/router/modules/office";
import donateRouter from "@/router/modules/donate";
import syncDataRouter from "@/router/modules/syncData"

Vue.use(Router)

/*
  redirect:                      if set to 'noredirect', no redirect action will be trigger when clicking the breadcrumb
  meta: {
    title: 'title'               the name showed in subMenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon showed in the sidebar
    breadcrumb: false            if false, the item will be hidden in breadcrumb (default is true)
    hidden: true                 if true, this route will not show in the sidebar (default is false)
  }
*/

export const constantRoutes: RouteConfig[] = [

  {
    path: '/redirect',
    component: Layout,
    meta: {hidden: true, auth: false},
    children: [{
      path: '/redirect/:path(.*)',
      component: () => import(/* webpackChunkName: "redirect" */ '@/views/redirect/index.vue')
    }]
  },
  {
    path: '/404',
    component: () => import(/* webpackChunkName: "404" */ '@/views/404.vue'),
    meta: {hidden: true, auth: false}
  },
  {
    path: '/login',
    name: 'login',
    component: () => import(/* webpackChunkName: "account" */ '@/views/account/login.vue'),
    meta: {
      title:'登录',
      hidden: true,
      auth: false
    }
  },
  {
    path: '/wxCallback',
    name: 'wxCallback',
    component: () => import(/* webpackChunkName: "account" */ '@/views/account/wxCallback.vue'),
    meta: {
      title:'企业微信登录',
      hidden: true,
      auth: false
    }
  },
  {
    path: '/generate/viewList',
    component: () => import(/* webpackChunkName: "404" */ '@/views/generateView/viewList.vue'),
    meta: {
      title: '列表页面生成器',
    }
  },
  {
    path: '/',
    component: Layout,
    redirect: '/dashboard',
    meta: {
      title: 'Dashboard',
    },
    children: [
      {
        path: 'dashboard',
        component: () => import(/* webpackChunkName: "dashboard" */ '@/views/dashboard/index.vue'),
        meta: {
          title: 'Dashboard',
        }
      },
    ]
  },
  {
    path: '/albumIframe',
    component: () => import(/* webpackChunkName: "dashboard" */ '@/components/Album/index.vue'),
    meta: {
      title: '相册管理',
    }
  },
  {
    path: '/audit',
    component: Layout,
    redirect: '',
    meta: {
      title: '我的待审核列表',
    },
    children: [
      {
        path: 'myAudit',
        name: 'myAudit',
        component: () => import(/* webpackChunkName: "audit" */ '@/views/myAudit/index.vue'),
        meta: {
          title: '我的待审核列表'
        }
      }
    ]
  },
  {
    path: '/',
    component: Layout,
    redirect: '/welcome',
    meta: {
      title: '',
    },
    children: [
      {
        path: 'welcome',
        component: () => import(/* webpackChunkName: "welcome" */ '@/views/welcome.vue'),
        meta: {
          title: '首页',
        }
      },
    ]
  },
]

// 动态加载菜单
export const asyncRouter: RouteConfig[] = [
  {
    path: '*',
    redirect: '/404',
    meta: {hidden: true}
  }
]

const router = new Router({
  // mode: 'history',  // Enable this if you need.
  scrollBehavior: (to, from, savedPosition) => {
    if (savedPosition) {
      return savedPosition
    } else {
      return {x: 0, y: 0}
    }
  },
  base: process.env.BASE_URL,

  routes: [
    ...constantRoutes,
    ...adminRouter,
    ...ouRouter,
    ...cmsRouter,
    ...financeRouter,
    ...asyncRouter,
    ...auditRouter,
    ...notifyRouter,
    ...organizationRouter,
    ...partnerInviteRouter,
    ...organizationApplyRouter,
    ...projectRouter,
    ...formRouter,
    ...fundRouter,
    ...fundProjectRouter,
    ...activityRouter,
    ...volunteerRouter,
    ...taskRouter,
    ...jobRouter,
    ...feedbackRouter,
    ...financeNewRouter,
    ...officeRouter,
    ...donateRouter,
    ...syncDataRouter
  ]
});

router.beforeEach(((to, from, next) => {
  const token = UserModule.token;
  if (token) {
    next();
  } else {
    if ((to.meta as any).auth !== false) {
      next({name: 'login', params: {returnUrl: to.fullPath}});
    } else {
      next();
    }
  }
}))

export default router;
